module.exports = __webpack_public_path__ + "2f36949d.png";